import api from "../../services/api";

/**
 * Lista as negociações de pagamento (bills to pay) com parcelas aninhadas.
 * Retorna a paginação do backend: { total, page, lastPage, data: [...] }.
 */
export async function listBillsToPay({ config, query = "" }) {
  const { data } = await api.get(`bill-to-pay-negotiations?${query}`, config);
  return data;
}
